import { css } from '@emotion/react'
import { Checkbox } from '@groovehq/internal-design-system/lib/components'
import React, { memo, useCallback } from 'react'

const checkboxStyle = css`
  margin-right: 24px;
`
const FollowCheckbox = props => {
  const { isFollowing, onFollowChange } = props

  const handleCheck = useCallback(
    event => {
      onFollowChange(event.currentTarget.checked)
    },
    [onFollowChange]
  )

  return (
    <Checkbox
      id="noteform-follow-box"
      css={checkboxStyle}
      checked={isFollowing}
      onChange={handleCheck}
    >
      Follow
    </Checkbox>
  )
}

export default memo(FollowCheckbox)
